import { single } from "rxjs/operators";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const modificaAnteprimaPDF: AnaColumn[] = [
  {
    itemType: "group", colCount: "1", class: 'no-line-caption mt-4', data: [ // class: 'mt-5'
      {
        type: 'campo', dataField: "titolo", nCol: 10, dataType: "", colSpan: '1', caption: "Titolo",
        //patterns: "^[a-zA-Z0-9'àòèéìù.,;: ]+$",
        validation: [
          { type: 'required', message: 'Il campo Titolo è obbligatorio' },
          { type: 'pattern', value: "^[a-zA-Z0-9'àòèéìù.,;: ]+$", message: 'Il campo Titolo può contenere solo lettere' },
        ]
      },
    ]
  },
  {
    itemType: "group", colCount: "1", class: 'no-line-caption mt-4', data: [ // class: 'mt-5'

      /*
      {
        type: 'campoSpecial', dataField: "formato", dataType: "", caption: "Formato",
        editorType: 'dxSelectBox',
        colVisible: false,
        nCol: 10,
        colSpan: '1',
        disableOnUpdate: false,
        uppercase:true,
        
        lista: {
          static: true,
          dataSource: 'formatiFoglio',
          valueExpr: 'id',
          displayExpr: 'descrizione',
         
          isMultiple:false
        },
        validation: [{
          type: 'required', message: 'È richiesto un formato'
        }],
      },
      */
      {
        type: 'campoSpecial', dataField: 'orientamento',
        colVisible: true,
        hideOnEdit: false,
        caption: 'Orientamento',
        class: 'allineaAlCentro',
        colSpan: '1',
        nCol: 10,
        editorType: 'dxRadioGroup',
        radioGroup: {
          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,
          items: [
            {
              icon: 'bi bi-file-earmark',
              value: 'l',
              descrizione: 'Orizzontale',
              alignment: 'center',
              class: 'icona-ruotata'
            },
            {
              icon: 'bi bi-file-earmark',
              value: 'p',
              descrizione: 'Verticale',
              alignment: 'center'
            },
          ],
        }
      }

    ]
  }]